import { Component, OnInit, Input, AfterContentInit, Output, EventEmitter } from '@angular/core';
import { MultipleOptionsInputBlockItemBase } from '../../../../core/models/physician/form-doc-builder';

@Component({
  selector: 'app-form-block-decision',
  templateUrl: './form-block-decision.component.html',
  styleUrls: ['./form-block-decision.component.scss']
})
export class FormBlockDecisionComponent implements OnInit, AfterContentInit {
  @Input() blockItem: MultipleOptionsInputBlockItemBase;
  @Output() onChange = new EventEmitter <MultipleOptionsInputBlockItemBase>();
  options: string;

  constructor() { }

  ngOnInit() {

  }
  ngAfterContentInit() {
    this.setValues();
  }
  setValues() {
    if (!this.blockItem.type) {
      this.blockItem.type = 1;
    }

    if (!this.blockItem.selectionOption) {
      this.blockItem.selectionOption = 0;
    }

    this.options = this.blockItem.options ? this.blockItem.options.join(',') : '';
  }

  splitOptions() {
    this.blockItem.options = this.options.split(',');
    //this.options = this.blockItem.options ? this.blockItem.options.join(',') : '';
  }
  valueChanged(value) {
    //console.log('valuechanged', value);
    if (value && value.length > 0)
      this.onChange.emit(this.blockItem);
    return true;
  }
}
